import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "form-group row"
}
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder text-uppercase" }, "Información de llegada", -1)
const _hoisted_7 = { class: "form-group row" }
const _hoisted_8 = { class: "col-lg-12" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = { class: "col-sm-12 col-md-4 col-lg-4" }
const _hoisted_11 = { class: "col-sm-12 col-md-4 col-lg-4" }
const _hoisted_12 = { class: "col-sm-12 col-md-4 col-lg-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder text-uppercase my-5" }, "Información de salida", -1)
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = { class: "col-lg-12" }
const _hoisted_16 = { class: "form-group row" }
const _hoisted_17 = { class: "col-sm-12 col-md-4 col-lg-4" }
const _hoisted_18 = { class: "col-sm-12 col-md-4 col-lg-4" }
const _hoisted_19 = { class: "col-sm-12 col-md-4 col-lg-4" }
const _hoisted_20 = { class: "form-group row" }
const _hoisted_21 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isModalVisible,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isModalVisible) = $event)),
    class: "rounded dialog-custom",
    title: _ctx.t('itinerary'),
    width: "600",
    top: "1vh",
    onOpen: _ctx.onOpen,
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_el_button, {
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isModalVisible=false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submitForm(_ctx.formRef)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Guardar ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(`card card-body bg-${_ctx.rowSelected.check_class} text-center mb-2`)
      }, [
        _createElementVNode("h6", {
          class: "m-0",
          innerHTML: _ctx.rowSelected.firstname + ' ' + _ctx.rowSelected.lastname + ' ' + _ctx.rowSelected.surname
        }, null, 8, _hoisted_1)
      ], 2),
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        ref: "formRef",
        model: _ctx.formIti,
        "status-icon": "",
        rules: _ctx.rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.formIti.status,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formIti.status) = $event)),
                label: "Llego y salgo por mis propios medio al hotel",
                size: "large"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.formIti.status)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_form_item, {
                    prop: "fecha1",
                    label: "Fecha de llegada",
                    rules: [{
                                required: true,
                                message: _ctx.t('obligatorie'),
                                trigger: ['blur', 'change']
                        }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formIti.fecha1,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formIti.fecha1) = $event)),
                        type: "date",
                        "value-format": "YYYY-MM-DD",
                        format: "DD/MM/YYYY",
                        placeholder: "dd/mm/yyyy"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_form_item, {
                    prop: "fecha2",
                    label: "Fecha de salida",
                    rules: [{
                                required: true,
                                message: _ctx.t('obligatorie'),
                                trigger: ['blur', 'change']
                        }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formIti.fecha2,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formIti.fecha2) = $event)),
                        type: "date",
                        "value-format": "YYYY-MM-DD",
                        format: "DD/MM/YYYY",
                        placeholder: "dd/mm/yyyy"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_form_item, {
                      prop: "aerolinea",
                      label: _ctx.t('aerolinea'),
                      rules: [{
                                required: true,
                                message: _ctx.t('obligatorie'),
                                trigger: ['blur', 'change']
                            }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formIti.aerolinea,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formIti.aerolinea) = $event)),
                          clearable: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label", "rules"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_form_item, {
                      prop: "vuelo",
                      label: _ctx.t('flightnumber'),
                      rules: [{
                                required: true,
                                message: _ctx.t('obligatorie'),
                                trigger: ['blur', 'change']
                            }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formIti.vuelo,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formIti.vuelo) = $event)),
                          clearable: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_el_form_item, {
                      prop: "fecha",
                      label: _ctx.t('arrivaldate'),
                      rules: [{
                                required: true,
                                message: _ctx.t('obligatorie'),
                                trigger: ['blur', 'change']
                            }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formIti.fecha,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formIti.fecha) = $event)),
                          type: "date",
                          placeholder: "dd/mm/yyyy",
                          "value-format": "YYYY-MM-DD",
                          format: "DD/MM/YYYY"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_el_form_item, {
                      prop: "hora",
                      label: _ctx.t('arrivaltime'),
                      rules: [{
                                required: true,
                                message: _ctx.t('obligatorie'),
                                trigger: ['blur', 'change']
                            }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_time_picker, {
                          modelValue: _ctx.formIti.hora,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formIti.hora) = $event)),
                          clearable: true,
                          format: "HH:mm",
                          "value-format": "HH:mm"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label", "rules"])
                  ])
                ]),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_el_form_item, {
                      prop: "aerolineaf",
                      label: _ctx.t('aerolinea'),
                      rules: [{
                                required: true,
                                message: _ctx.t('obligatorie'),
                                trigger: ['blur', 'change']
                            }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formIti.aerolineaf,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formIti.aerolineaf) = $event)),
                          clearable: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label", "rules"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_el_form_item, {
                      prop: "vuelof",
                      label: _ctx.t('flightnumber'),
                      rules: [{
                                required: true,
                                message: _ctx.t('obligatorie'),
                                trigger: ['blur', 'change']
                            }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formIti.vuelof,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formIti.vuelof) = $event)),
                          clearable: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_form_item, {
                      prop: "fechaf",
                      label: _ctx.t('departuredate'),
                      rules: [{
                                required: true,
                                message: _ctx.t('obligatorie'),
                                trigger: ['blur', 'change']
                            }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formIti.fechaf,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formIti.fechaf) = $event)),
                          type: "date",
                          "value-format": "YYYY-MM-DD",
                          format: "DD/MM/YYYY",
                          placeholder: "dd/mm/yyyy"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_el_form_item, {
                      prop: "horaf",
                      label: _ctx.t('departuretime'),
                      rules: [{
                                required: true,
                                message: _ctx.t('obligatorie'),
                                trigger: ['blur', 'change']
                            }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_time_picker, {
                          modelValue: _ctx.formIti.horaf,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formIti.horaf) = $event)),
                          clearable: true,
                          format: "HH:mm",
                          "value-format": "HH:mm"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label", "rules"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_el_form_item, {
                    prop: "mstatus",
                    label: _ctx.t('state'),
                    rules: [{
                                required: true,
                                message: _ctx.t('obligatorie'),
                                trigger: ['blur', 'change']
                            }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formIti.mstatus,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formIti.mstatus) = $event)),
                        placeholder: "Seleccione un estado"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([{value: '1', label: 'Confirmado'}, {value: '2', label: 'Cancelado'}, {value: '3', label: 'Pendiente'}], (item) => {
                            return _createVNode(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "rules"])
                ])
              ]))
        ]),
        _: 1
      }, 8, ["model", "rules"])), [
        [_directive_loading, _ctx.loaderIti]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onOpen", "onOpened", "onClosed"]))
}